import { gql } from '@apollo/client';

export const fetchBulkContactDetailsFromContactService = gql`
  query fetchBulkContactDetailsFromContactService(
    $resourceAris: [String]
    $contactType: [ContactType]
    $transactionAccountId: String
  ) {
    bulkContactsByResource(
      resourceAris: $resourceAris
      contactType: $contactType
      transactionAccountId: $transactionAccountId
    ) {
      accountId
      email
      name
      picture
      updatedAt
      isPrimary
      identifierId
    }
  }
`;
